import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import WaferField from "@/components/WaferField";

export default function About() {
    return (
        <div>
            <section className="relative overflow-hidden py-24">
                <WaferField />
                <div className="mx-auto max-w-3xl px-5 text-center">
                    <Reveal>
                        <p className="text-sm font-semibold uppercase tracking-widest text-caramel">Our Story</p>
                        <h1 className="mt-3 font-serif text-4xl font-semibold text-roast sm:text-6xl">The pearl in every spoonful</h1>
                    </Reveal>
                </div>
            </section>

            <section className="mx-auto max-w-4xl px-5 pb-16 lg:px-8">
                <div className="prose prose-lg mx-auto max-w-2xl text-roast/80">
                    <Reveal>
                        <p className="text-lg leading-relaxed">
                            <span className="float-left mr-3 font-serif text-6xl leading-[0.8] text-caramel">S</span>
                            weet Pearls began the way most good things do — in a small kitchen, with a single well-loved recipe and a lot of patience. We were chasing a specific memory: the banana pudding that tasted like celebration, the kind that disappeared before the party even started.
                        </p>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="mt-6 leading-relaxed text-mocha">
                            We call it Pearls because a truly great dessert is rare and precious — layered like little treasures of velvety custard, ripe banana and golden wafers. Every batch is folded by hand, never rushed, and made fresh each morning. No shortcuts, no fillers, no artificial anything.
                        </p>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <p className="mt-6 leading-relaxed text-mocha">
                            Today we serve our neighborhood and ship nationwide, but the heart hasn't changed: real ingredients, small batches, and a belief that a single spoonful can turn an ordinary moment into something special.
                        </p>
                    </Reveal>
                </div>
                <Reveal>
                    <div className="mt-12 text-center">
                        <Link to="/shop" className="inline-flex rounded-full bg-banana px-8 py-3.5 font-semibold text-roast shadow-pill hover:bg-banana-hover">Taste for yourself</Link>
                    </div>
                </Reveal>
            </section>

            <section className="bg-cream-200 py-16">
                <div className="mx-auto grid max-w-5xl gap-8 px-5 text-center sm:grid-cols-3">
                    {[["100%", "Handcrafted daily"], ["6+", "Signature flavors"], ["1,500+", "Happy customers"]].map(([n, l], i) => (
                        <Reveal key={l} delay={i * 0.08}>
                            <p className="font-serif text-5xl text-caramel">{n}</p>
                            <p className="mt-1 text-mocha">{l}</p>
                        </Reveal>
                    ))}
                </div>
            </section>
        </div>
    );
}
